import { useState } from "react";
import SectionLabel from "@/components/base/SectionLabel";
import { dxAdvisoryData } from "@/mocks/dxAdvisoryData";

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14 reveal">
          <SectionLabel label={dxAdvisoryData.faq.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {dxAdvisoryData.faq.title}
          </h2>
        </div>

        <div className="space-y-3 md:space-y-4">
          {dxAdvisoryData.faq.items.map((item, idx) => (
            <div
              key={idx}
              className="reveal rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm md:text-base font-bold text-foreground-900 font-heading pr-2">
                  {item.q}
                </span>
                <span
                  className={`flex-shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full bg-primary-100 flex items-center justify-center transition-transform duration-300 ${
                    openIdx === idx ? "rotate-180" : ""
                  }`}
                >
                  <i className="ri-arrow-down-s-line text-primary-600 text-sm md:text-base" />
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? "max-h-96" : "max-h-0"
                }`}
              >
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <div className="pt-1 border-t border-background-200/70">
                    <p className="pt-3 md:pt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8 md:mt-10 reveal">
          <a
            href="/faq"
            className="inline-flex items-center gap-1.5 text-sm md:text-base font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            よくある質問をもっと見る
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}